export interface DateTimeProvider {
  get(): Date
}

export class RealDateTimeProvider implements DateTimeProvider {
  get(): Date {
    return new Date()
  }
}

export class MockedDateTimeProvider implements DateTimeProvider {
  constructor(public date: Date) {}
  set(date: Date) {
    this.date = date
  }
  get(): Date {
    return this.date
  }
}

export class MockedSequenceDateTimeProvider implements DateTimeProvider {
  private current = 0
  get(): Date {
    return new Date(this.current++)
  }
}
